import { createDuoToneIcon } from '@ps/ds/icons/helpers/createDuoToneIcon'

export const ProgressDoneDuoTone = createDuoToneIcon(
  'ProgressDoneDuoTone',
  [
    [
      'path',
      {
        d: 'M21.125 12C21.125 6.9604 17.0396 2.875 12 2.875C6.9604 2.875 2.875 6.9604 2.875 12C2.875 17.0396 6.9604 21.125 12 21.125C17.0396 21.125 21.125 17.0396 21.125 12ZM22.875 12C22.875 18.0061 18.0061 22.875 12 22.875C5.9939 22.875 1.125 18.0061 1.125 12C1.125 5.9939 5.9939 1.125 12 1.125C18.0061 1.125 22.875 5.9939 22.875 12Z',
        stroke: 'none',
        key: 'ProgressDoneDuoTone-0',
      },
    ],
    [
      'path',
      {
        d: 'M4.5 12a7.5 7.5 0 1 0 15 0a7.5 7.5 0 1 0 -15 0',
        stroke: 'none',
        key: 'ProgressDoneDuoTone-1',
      },
    ],
    [
      'path',
      {
        d: 'M14.2563 9.75628C14.598 9.41457 15.1529 9.41457 15.4946 9.75628C15.8363 10.098 15.8363 10.6529 15.4946 10.9946L11.4946 14.9946C11.1529 15.3363 10.598 15.3363 10.2563 14.9946L8.25628 12.9946C7.91457 12.6529 7.91457 12.098 8.25628 11.7563C8.59799 11.4146 9.15285 11.4146 9.49456 11.7563L10.8754 13.1371L14.2563 9.75628Z',
        fill: 'white',
        stroke: 'none',
        key: 'ProgressDoneDuoTone-2',
      },
    ],
  ],
  {
    foregroundStartIndex: 2,
    defaultForegroundClassName: 'fill-background',
  },
)

ProgressDoneDuoTone.displayName = 'ProgressDoneDuoTone'
